/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Preview_EmptyInputs */

const en_carrier_notices_preview_empty = /** @type {(inputs: Carrier_Notices_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a message to preview the checkout warning.`)
};

const es_carrier_notices_preview_empty = /** @type {(inputs: Carrier_Notices_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un mensaje para ver la advertencia de checkout.`)
};

/**
* | output |
* | --- |
* | "Enter a message to preview the checkout warning." |
*
* @param {Carrier_Notices_Preview_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_preview_empty = /** @type {((inputs?: Carrier_Notices_Preview_EmptyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Preview_EmptyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_preview_empty(inputs)
	return es_carrier_notices_preview_empty(inputs)
});